import { render, staticRenderFns } from "./LanguageWordsView.vue?vue&type=template&id=ebaa0a04&scoped=true"
import script from "./LanguageWordsView.vue?vue&type=script&lang=ts"
export * from "./LanguageWordsView.vue?vue&type=script&lang=ts"
import style0 from "./LanguageWordsView.vue?vue&type=style&index=0&id=ebaa0a04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebaa0a04",
  null
  
)

export default component.exports